import React from 'react';
import { Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';

import alyceLogo from '../../assets/images/alyce-logo.svg';

const useStyles = makeStyles(({ palette, spacing }) => ({
  logo: {
    height: 34,
    width: 150,
    marginBottom: spacing(4),
  },
  messageHeader: {
    textAlign: 'left',
    fontSize: 20,
    color: palette.text.primary,
    fontWeight: 400,
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 1.33,
    letterSpacing: 'normal',
  },
}));

const MessageHeader = () => {
  const classes = useStyles();

  return (
    <Grid container direction="row">
      <Grid item xs={12}>
        <img className={classes.logo} src={alyceLogo} alt="Alyce" />
      </Grid>
      <Grid item xs={12}>
        <Typography className={classes.messageHeader}>You got a sweet gift. Here are your options.</Typography>
      </Grid>
    </Grid>
  );
};

export default MessageHeader;
